
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.6.0
 * Query Engine version: f676762280b54cd07c770017ed3711ddde35f37a
 */
Prisma.prismaVersion = {
  client: "6.6.0",
  engine: "f676762280b54cd07c770017ed3711ddde35f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AssessmentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  hash: 'hash',
  subid: 'subid',
  type: 'type',
  status: 'status',
  comments: 'comments',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  processedAt: 'processedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.AssessmentRuleScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  ruleId: 'ruleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.BrandingScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  primaryColor: 'primaryColor',
  logoUrl: 'logoUrl'
};

exports.Prisma.BoostScalarFieldEnum = {
  id: 'id',
  type: 'type',
  title: 'title',
  subtitle: 'subtitle',
  eval: 'eval',
  media: 'media',
  video: 'video',
  content: 'content',
  elementarySchool: 'elementarySchool',
  highSchool: 'highSchool',
  middleSchool: 'middleSchool',
  code: 'code',
  category: 'category',
  subject: 'subject',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ConfigScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  brandingId: 'brandingId'
};

exports.Prisma.ContactFormScalarFieldEnum = {
  id: 'id',
  first: 'first',
  last: 'last',
  email: 'email',
  phone: 'phone',
  role: 'role',
  org: 'org',
  comments: 'comments',
  updates: 'updates',
  demo: 'demo',
  source: 'source',
  purchase: 'purchase',
  createdAt: 'createdAt'
};

exports.Prisma.CustomRuleScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  type: 'type',
  label: 'label',
  content: 'content',
  order: 'order',
  version: 'version',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ExternalIdScalarFieldEnum = {
  id: 'id',
  entityType: 'entityType',
  entityId: 'entityId',
  providerId: 'providerId',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.IntegrationScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  accessToken: 'accessToken',
  organizationId: 'organizationId',
  lastEventId: 'lastEventId',
  identifierType: 'identifierType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LiftScalarFieldEnum = {
  id: 'id',
  boostId: 'boostId',
  type: 'type',
  title: 'title',
  subtitle: 'subtitle',
  eval: 'eval',
  media: 'media',
  video: 'video',
  content: 'content',
  elementarySchool: 'elementarySchool',
  highSchool: 'highSchool',
  middleSchool: 'middleSchool',
  code: 'code',
  subject: 'subject',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  nweaDistrictBid: 'nweaDistrictBid',
  oldOrgId: 'oldOrgId',
  name: 'name',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.PredictiveOutcomeScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  metricType: 'metricType',
  subjectArea: 'subjectArea',
  sourceAssessmentType: 'sourceAssessmentType',
  sourceAssessmentDate: 'sourceAssessmentDate',
  sourceMetadata: 'sourceMetadata',
  sourceOutcome: 'sourceOutcome',
  deltaOutcome: 'deltaOutcome',
  predictedOutcome: 'predictedOutcome',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  deletedAt: 'deletedAt'
};

exports.Prisma.ProductBySkillScalarFieldEnum = {
  id: 'id',
  schoolLevel: 'schoolLevel',
  academicSection: 'academicSection',
  verbReasAcc: 'verbReasAcc',
  verbReasSpd: 'verbReasSpd',
  verbMemAcc: 'verbMemAcc',
  attentionAcc: 'attentionAcc',
  verbReasEff: 'verbReasEff',
  spaPercepAcc: 'spaPercepAcc',
  workMemAcc: 'workMemAcc',
  attentionSpd: 'attentionSpd',
  absReasAcc: 'absReasAcc',
  absReasEff: 'absReasEff',
  flexThinkAcc: 'flexThinkAcc',
  visMotorSpd: 'visMotorSpd',
  visMemEff: 'visMemEff',
  performancePrediction: 'performancePrediction',
  product1: 'product1',
  product2: 'product2',
  product3: 'product3',
  moreProducts: 'moreProducts',
  deletedAt: 'deletedAt'
};

exports.Prisma.ProfileImageScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  url: 'url',
  background: 'background',
  defaultImage: 'defaultImage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ReportScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  type: 'type',
  status: 'status',
  version: 'version',
  accessible: 'accessible',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ReportAccessLogScalarFieldEnum = {
  id: 'id',
  eventTimestamp: 'eventTimestamp',
  reportId: 'reportId',
  userId: 'userId',
  eventType: 'eventType'
};

exports.Prisma.ReportFlagScalarFieldEnum = {
  id: 'id',
  reportId: 'reportId',
  flagType: 'flagType',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.RosterScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.RosterMemberScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  rosterId: 'rosterId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.RuleScalarFieldEnum = {
  id: 'id',
  datasetid: 'datasetid',
  expression: 'expression',
  category: 'category',
  tier: 'tier',
  parentTier: 'parentTier',
  reportType: 'reportType',
  minorCategory: 'minorCategory',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.RuleTemplateScalarFieldEnum = {
  id: 'id',
  ruleId: 'ruleId',
  label: 'label',
  content: 'content',
  type: 'type',
  version: 'version',
  index: 'index',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ScoreScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  verbalReasoningAccuracy: 'verbalReasoningAccuracy',
  verbalReasoningEfficiency: 'verbalReasoningEfficiency',
  verbalReasoningSpeed: 'verbalReasoningSpeed',
  verbalReasoningValidity: 'verbalReasoningValidity',
  abstractReasoningAccuracy: 'abstractReasoningAccuracy',
  abstractReasoningEfficiency: 'abstractReasoningEfficiency',
  abstractReasoningSpeed: 'abstractReasoningSpeed',
  abstractReasoningValidity: 'abstractReasoningValidity',
  spatialPerceptionAccuracy: 'spatialPerceptionAccuracy',
  spatialPerceptionEfficiency: 'spatialPerceptionEfficiency',
  spatialPerceptionSpeed: 'spatialPerceptionSpeed',
  spatialPerceptionValidity: 'spatialPerceptionValidity',
  verbalMemoryAccuracy: 'verbalMemoryAccuracy',
  verbalMemoryEfficiency: 'verbalMemoryEfficiency',
  verbalMemorySpeed: 'verbalMemorySpeed',
  verbalMemoryValidity: 'verbalMemoryValidity',
  visualMemoryAccuracy: 'visualMemoryAccuracy',
  visualMemoryEfficiency: 'visualMemoryEfficiency',
  visualMemorySpeed: 'visualMemorySpeed',
  visualMemoryValidity: 'visualMemoryValidity',
  attentionAccuracy: 'attentionAccuracy',
  attentionEfficiency: 'attentionEfficiency',
  attentionSpeed: 'attentionSpeed',
  attentionValidity: 'attentionValidity',
  workingMemoryAccuracy: 'workingMemoryAccuracy',
  workingMemoryEfficiency: 'workingMemoryEfficiency',
  workingMemorySpeed: 'workingMemorySpeed',
  workingMemoryValidity: 'workingMemoryValidity',
  flexibleThinkingAccuracy: 'flexibleThinkingAccuracy',
  flexibleThinkingEfficiency: 'flexibleThinkingEfficiency',
  flexibleThinkingSpeed: 'flexibleThinkingSpeed',
  flexibleThinkingValidity: 'flexibleThinkingValidity',
  processingSpeedAccuracy: 'processingSpeedAccuracy',
  processingSpeedEfficiency: 'processingSpeedEfficiency',
  processingSpeedSpeed: 'processingSpeedSpeed',
  processingSpeedValidity: 'processingSpeedValidity',
  visualMotorSpeedAccuracy: 'visualMotorSpeedAccuracy',
  visualMotorSpeedEfficiency: 'visualMotorSpeedEfficiency',
  visualMotorSpeedSpeed: 'visualMotorSpeedSpeed',
  visualMotorSpeedValidity: 'visualMotorSpeedValidity',
  reversals: 'reversals',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ScoreCnbScalarFieldEnum = {
  id: 'id',
  datasetid: 'datasetid',
  SM_A: 'SM_A',
  SM_Az: 'SM_Az',
  SM_S: 'SM_S',
  SM_Sz: 'SM_Sz',
  SM_NormSet: 'SM_NormSet',
  SM_NormStrata: 'SM_NormStrata',
  VMEM_A: 'VMEM_A',
  VMEM_Az: 'VMEM_Az',
  VMEM_S: 'VMEM_S',
  VMEM_Sz: 'VMEM_Sz',
  VMEM_NormSet: 'VMEM_NormSet',
  VMEM_NormStrata: 'VMEM_NormStrata',
  ABF_A: 'ABF_A',
  ABF_Az: 'ABF_Az',
  ABF_S: 'ABF_S',
  ABF_Sz: 'ABF_Sz',
  ABF_NormSet: 'ABF_NormSet',
  ABF_NormStrata: 'ABF_NormStrata',
  LAN_A: 'LAN_A',
  LAN_Az: 'LAN_Az',
  LAN_S: 'LAN_S',
  LAN_Sz: 'LAN_Sz',
  LAN_NormSet: 'LAN_NormSet',
  LAN_NormStrata: 'LAN_NormStrata',
  NVR_A: 'NVR_A',
  NVR_Az: 'NVR_Az',
  NVR_S: 'NVR_S',
  NVR_Sz: 'NVR_Sz',
  NVR_NormSet: 'NVR_NormSet',
  NVR_NormStrata: 'NVR_NormStrata',
  WM_A: 'WM_A',
  WM_Az: 'WM_Az',
  WM_S: 'WM_S',
  WM_Sz: 'WM_Sz',
  WM_NormSet: 'WM_NormSet',
  WM_NormStrata: 'WM_NormStrata',
  ATT_A: 'ATT_A',
  ATT_Az: 'ATT_Az',
  ATT_S: 'ATT_S',
  ATT_Sz: 'ATT_Sz',
  ATT_NormSet: 'ATT_NormSet',
  ATT_NormStrata: 'ATT_NormStrata',
  SMEM_A: 'SMEM_A',
  SMEM_Az: 'SMEM_Az',
  SMEM_S: 'SMEM_S',
  SMEM_Sz: 'SMEM_Sz',
  SMEM_NormSet: 'SMEM_NormSet',
  SMEM_NormStrata: 'SMEM_NormStrata',
  SPA_A: 'SPA_A',
  SPA_Az: 'SPA_Az',
  SPA_S: 'SPA_S',
  SPA_Sz: 'SPA_Sz',
  SPA_NormSet: 'SPA_NormSet',
  SPA_NormStrata: 'SPA_NormStrata',
  exefun_A_z: 'exefun_A_z',
  exefun_S_z: 'exefun_S_z',
  exefun_wiv_A_z: 'exefun_wiv_A_z',
  exefun_wiv_S_z: 'exefun_wiv_S_z',
  comcog_A_z: 'comcog_A_z',
  comcog_S_z: 'comcog_S_z',
  comcog_wiv_A_z: 'comcog_wiv_A_z',
  comcog_wiv_S_z: 'comcog_wiv_S_z',
  mot_A_z: 'mot_A_z',
  mot_S_z: 'mot_S_z',
  ciq_A_z: 'ciq_A_z',
  wiv_A_z: 'wiv_A_z',
  CPW_ER: 'CPW_ER',
  CPW_RTER: 'CPW_RTER',
  CPW_TP: 'CPW_TP',
  CPW_TN: 'CPW_TN',
  CPW_TPRT: 'CPW_TPRT',
  CPW_TNRT: 'CPW_TNRT',
  CPW_FP: 'CPW_FP',
  CPW_FN: 'CPW_FN',
  CPW_FPRT: 'CPW_FPRT',
  CPW_FNRT: 'CPW_FNRT',
  KSPVRTD_PC: 'KSPVRTD_PC',
  KSPVRTD_RTER: 'KSPVRTD_RTER',
  PCET_CR: 'PCET_CR',
  PCET_ER: 'PCET_ER',
  PCET_RTER: 'PCET_RTER',
  PCET_CAT: 'PCET_CAT',
  PCET_CAT1_TR: 'PCET_CAT1_TR',
  PCET_CAT2_TR: 'PCET_CAT2_TR',
  PCET_CAT3_TR: 'PCET_CAT3_TR',
  PCET_ACC2: 'PCET_ACC2',
  PCET_ACC2z: 'PCET_ACC2z',
  PMAT24_B_SI: 'PMAT24_B_SI',
  PMAT24_B_RTER: 'PMAT24_B_RTER',
  PMAT24_B_RTTO: 'PMAT24_B_RTTO',
  SLNB2_TP: 'SLNB2_TP',
  SLNB2_FP: 'SLNB2_FP',
  SLNB2_RTC: 'SLNB2_RTC',
  SLNB2_TP0: 'SLNB2_TP0',
  SLNB2_FP0: 'SLNB2_FP0',
  SLNB2_RTC0: 'SLNB2_RTC0',
  SLNB2_FPRT0: 'SLNB2_FPRT0',
  SLNB2_TP1: 'SLNB2_TP1',
  SLNB2_FP1: 'SLNB2_FP1',
  SLNB2_RTC1: 'SLNB2_RTC1',
  SLNB2_FPRT1: 'SLNB2_FPRT1',
  SLNB2_TP2: 'SLNB2_TP2',
  SLNB2_FP2: 'SLNB2_FP2',
  SLNB2_RTC2: 'SLNB2_RTC2',
  SLNB2_FPRT2: 'SLNB2_FPRT2',
  SLNB2_LRNR: 'SLNB2_LRNR',
  SLNB2_LRR: 'SLNB2_LRR',
  SLNB2_FRNR: 'SLNB2_FRNR',
  SCPN_TP: 'SCPN_TP',
  SCPN_FP: 'SCPN_FP',
  SCPN_TN: 'SCPN_TN',
  SCPN_FN: 'SCPN_FN',
  SCPN_TPRT: 'SCPN_TPRT',
  SCPN_FPRT: 'SCPN_FPRT',
  SCPL_TP: 'SCPL_TP',
  SCPL_FP: 'SCPL_FP',
  SCPL_TN: 'SCPL_TN',
  SCPL_FN: 'SCPL_FN',
  SCPL_TPRT: 'SCPL_TPRT',
  SCPL_FPRT: 'SCPL_FPRT',
  SCPT_FRNR: 'SCPT_FRNR',
  SCPT_LRNR: 'SCPT_LRNR',
  SCPT_REV_FP: 'SCPT_REV_FP',
  SCPT_REV_FPRT: 'SCPT_REV_FPRT',
  SCPT_REV_FN: 'SCPT_REV_FN',
  SVOLT_ER: 'SVOLT_ER',
  SVOLT_RTER: 'SVOLT_RTER',
  SVOLT_TP: 'SVOLT_TP',
  SVOLT_TN: 'SVOLT_TN',
  SVOLT_TPRT: 'SVOLT_TPRT',
  SVOLT_TNRT: 'SVOLT_TNRT',
  SVOLT_FP: 'SVOLT_FP',
  SVOLT_FN: 'SVOLT_FN',
  SVOLT_FPRT: 'SVOLT_FPRT',
  SVOLT_FNRT: 'SVOLT_FNRT',
  SVOLT_LRNR: 'SVOLT_LRNR',
  VSPLOT24_ER: 'VSPLOT24_ER',
  VSPLOT24_RTER: 'VSPLOT24_RTER',
  VSPLOT24_TOT_RT: 'VSPLOT24_TOT_RT',
  VSPLOT24_OFF: 'VSPLOT24_OFF',
  VSPLOT24_SUM_EXCESS: 'VSPLOT24_SUM_EXCESS',
  VSPLOT24_SUM_DEFICIT: 'VSPLOT24_SUM_DEFICIT',
  VSPLOT24_SUM_DEG_OFF: 'VSPLOT24_SUM_DEG_OFF',
  exefun_age: 'exefun_age',
  comcog_age: 'comcog_age',
  CPW_LRSR: 'CPW_LRSR',
  CPW_CNT_200: 'CPW_CNT_200',
  PCET_LRSR: 'PCET_LRSR',
  KSPVRTD_LRSR: 'KSPVRTD_LRSR',
  KSPVRTD_CNT_750: 'KSPVRTD_CNT_750',
  SLNB2_CNT_200: 'SLNB2_CNT_200',
  SVOLT_LRSR: 'SVOLT_LRSR',
  SVOLT_CNT_200: 'SVOLT_CNT_200',
  SVOLT_NR: 'SVOLT_NR',
  SM_z_eff: 'SM_z_eff',
  VMEM_z_eff: 'VMEM_z_eff',
  ABF_z_eff: 'ABF_z_eff',
  LAN_z_eff: 'LAN_z_eff',
  NVR_z_eff: 'NVR_z_eff',
  WM_z_eff: 'WM_z_eff',
  ATT_z_eff: 'ATT_z_eff',
  SMEM_z_eff: 'SMEM_z_eff',
  SPA_z_eff: 'SPA_z_eff',
  PROC_S_z: 'PROC_S_z',
  assessmentId: 'assessmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.SectionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  siteId: 'siteId',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.SiteScalarFieldEnum = {
  id: 'id',
  name: 'name',
  oldSiteId: 'oldSiteId',
  organizationId: 'organizationId',
  address: 'address',
  city: 'city',
  state: 'state',
  zip: 'zip',
  externalId: 'externalId',
  nweaSchoolBid: 'nweaSchoolBid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.StudentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  dob: 'dob',
  gradeLevel: 'gradeLevel',
  gender: 'gender',
  schoolId: 'schoolId',
  nweaStudentBid: 'nweaStudentBid',
  testCode: 'testCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TenantScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  accountState: 'accountState',
  parentId: 'parentId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TenantIntegrationScalarFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  providerId: 'providerId',
  integrationDetails: 'integrationDetails',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ThirdPartyProviderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TrialScalarFieldEnum = {
  id: 'id',
  trialCodeId: 'trialCodeId',
  assessmentId: 'assessmentId',
  email: 'email',
  emailSent: 'emailSent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.TrialAccountScalarFieldEnum = {
  id: 'id',
  trialId: 'trialId',
  email: 'email',
  token: 'token',
  subid: 'subid',
  testType: 'testType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt'
};

exports.Prisma.TrialCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  type: 'type',
  siteId: 'siteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  profileImage: 'profileImage',
  firstName: 'firstName',
  lastName: 'lastName',
  role: 'role',
  externalId: 'externalId',
  oldUserId: 'oldUserId',
  active: 'active',
  lastLogin: 'lastLogin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserOrganizationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserSectionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  sectionId: 'sectionId',
  externalId: 'externalId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserSiteScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  siteId: 'siteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.UserTokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  access: 'access',
  refresh: 'refresh',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.Q_instancesScalarFieldEnum = {
  id: 'id',
  customer_id: 'customer_id',
  questionnaire_id: 'questionnaire_id',
  question_id: 'question_id',
  option_id: 'option_id',
  option_key: 'option_key',
  option_val: 'option_val',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_map_customer_questionnaireScalarFieldEnum = {
  id: 'id',
  customer_id: 'customer_id',
  questionnaire_id: 'questionnaire_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_map_option_cognitive_skillScalarFieldEnum = {
  id: 'id',
  feature_cognitive_skill_id: 'feature_cognitive_skill_id',
  q_option_id: 'q_option_id',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_map_option_questionScalarFieldEnum = {
  id: 'id',
  option_id: 'option_id',
  question_id: 'question_id',
  trigger_question_id: 'trigger_question_id',
  show_in_lp: 'show_in_lp',
  ordinal: 'ordinal',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_map_question_questionnaireScalarFieldEnum = {
  id: 'id',
  question_id: 'question_id',
  questionnaire_id: 'questionnaire_id',
  section_id: 'section_id',
  type: 'type',
  limit: 'limit',
  show_in_lp: 'show_in_lp',
  ordinal: 'ordinal',
  show_as_self_reported_weakness: 'show_as_self_reported_weakness',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_map_questionnaire_sectionScalarFieldEnum = {
  id: 'id',
  questionnaire_id: 'questionnaire_id',
  section_id: 'section_id',
  ordinal: 'ordinal',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_optionsScalarFieldEnum = {
  id: 'id',
  label: 'label',
  key: 'key',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_questionnairesScalarFieldEnum = {
  id: 'id',
  name: 'name',
  subtitle: 'subtitle',
  created_at: 'created_at',
  updated_at: 'updated_at',
  override: 'override',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_questionsScalarFieldEnum = {
  id: 'id',
  label: 'label',
  name: 'name',
  subtext: 'subtext',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_sectionsScalarFieldEnum = {
  id: 'id',
  label: 'label',
  subtext: 'subtext',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.Q_sharedScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  customer_id: 'customer_id',
  questionnaire_id: 'questionnaire_id',
  token: 'token',
  viewed_at: 'viewed_at',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.V1_users_reportsScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  customer_id: 'customer_id',
  subid: 'subid',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  student_access: 'student_access'
};

exports.Prisma.V1_rules_importScalarFieldEnum = {
  id: 'id',
  datasetid: 'datasetid',
  expression: 'expression',
  category: 'category',
  tier: 'tier',
  parent_tier: 'parent_tier',
  report_type: 'report_type',
  minor_category: 'minor_category',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.V1_rules_templates_importScalarFieldEnum = {
  id: 'id',
  datasetid: 'datasetid',
  rule_id: 'rule_id',
  label: 'label',
  content: 'content',
  type: 'type',
  version: 'version',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  index: 'index'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.AssessmentOrderByRelevanceFieldEnum = {
  hash: 'hash',
  subid: 'subid',
  comments: 'comments'
};

exports.Prisma.BrandingOrderByRelevanceFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  primaryColor: 'primaryColor',
  logoUrl: 'logoUrl'
};

exports.Prisma.BoostOrderByRelevanceFieldEnum = {
  type: 'type',
  title: 'title',
  subtitle: 'subtitle',
  media: 'media',
  video: 'video',
  content: 'content',
  code: 'code'
};

exports.Prisma.ConfigOrderByRelevanceFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  brandingId: 'brandingId'
};

exports.Prisma.ContactFormOrderByRelevanceFieldEnum = {
  first: 'first',
  last: 'last',
  email: 'email',
  phone: 'phone',
  org: 'org',
  comments: 'comments',
  source: 'source'
};

exports.Prisma.CustomRuleOrderByRelevanceFieldEnum = {
  label: 'label',
  content: 'content'
};

exports.Prisma.ExternalIdOrderByRelevanceFieldEnum = {
  id: 'id',
  entityId: 'entityId',
  providerId: 'providerId',
  externalId: 'externalId'
};

exports.Prisma.IntegrationOrderByRelevanceFieldEnum = {
  externalId: 'externalId',
  accessToken: 'accessToken',
  lastEventId: 'lastEventId',
  identifierType: 'identifierType'
};

exports.Prisma.LiftOrderByRelevanceFieldEnum = {
  type: 'type',
  title: 'title',
  subtitle: 'subtitle',
  media: 'media',
  video: 'video',
  content: 'content',
  code: 'code'
};

exports.Prisma.OrganizationOrderByRelevanceFieldEnum = {
  externalId: 'externalId',
  nweaDistrictBid: 'nweaDistrictBid',
  name: 'name',
  type: 'type'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.PredictiveOutcomeOrderByRelevanceFieldEnum = {
  subjectArea: 'subjectArea',
  sourceAssessmentDate: 'sourceAssessmentDate'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ProductBySkillOrderByRelevanceFieldEnum = {
  schoolLevel: 'schoolLevel',
  academicSection: 'academicSection',
  performancePrediction: 'performancePrediction',
  moreProducts: 'moreProducts'
};

exports.Prisma.ProfileImageOrderByRelevanceFieldEnum = {
  url: 'url',
  background: 'background',
  defaultImage: 'defaultImage'
};

exports.Prisma.ReportFlagOrderByRelevanceFieldEnum = {
  description: 'description'
};

exports.Prisma.RosterOrderByRelevanceFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  name: 'name'
};

exports.Prisma.RosterMemberOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  rosterId: 'rosterId'
};

exports.Prisma.RuleOrderByRelevanceFieldEnum = {
  datasetid: 'datasetid'
};

exports.Prisma.RuleTemplateOrderByRelevanceFieldEnum = {
  label: 'label',
  content: 'content'
};

exports.Prisma.ScoreCnbOrderByRelevanceFieldEnum = {
  SM_NormSet: 'SM_NormSet',
  SM_NormStrata: 'SM_NormStrata',
  VMEM_NormSet: 'VMEM_NormSet',
  VMEM_NormStrata: 'VMEM_NormStrata',
  ABF_NormSet: 'ABF_NormSet',
  ABF_NormStrata: 'ABF_NormStrata',
  LAN_NormSet: 'LAN_NormSet',
  LAN_NormStrata: 'LAN_NormStrata',
  NVR_NormSet: 'NVR_NormSet',
  NVR_NormStrata: 'NVR_NormStrata',
  WM_NormSet: 'WM_NormSet',
  WM_NormStrata: 'WM_NormStrata',
  ATT_NormSet: 'ATT_NormSet',
  ATT_NormStrata: 'ATT_NormStrata',
  SMEM_NormSet: 'SMEM_NormSet',
  SMEM_NormStrata: 'SMEM_NormStrata',
  SPA_NormSet: 'SPA_NormSet',
  SPA_NormStrata: 'SPA_NormStrata'
};

exports.Prisma.SectionOrderByRelevanceFieldEnum = {
  name: 'name',
  externalId: 'externalId'
};

exports.Prisma.SiteOrderByRelevanceFieldEnum = {
  name: 'name',
  address: 'address',
  city: 'city',
  state: 'state',
  zip: 'zip',
  externalId: 'externalId',
  nweaSchoolBid: 'nweaSchoolBid'
};

exports.Prisma.StudentOrderByRelevanceFieldEnum = {
  schoolId: 'schoolId',
  nweaStudentBid: 'nweaStudentBid',
  testCode: 'testCode'
};

exports.Prisma.TenantOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  parentId: 'parentId'
};

exports.Prisma.TenantIntegrationOrderByRelevanceFieldEnum = {
  id: 'id',
  tenantId: 'tenantId',
  providerId: 'providerId'
};

exports.Prisma.ThirdPartyProviderOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.TrialOrderByRelevanceFieldEnum = {
  email: 'email'
};

exports.Prisma.TrialAccountOrderByRelevanceFieldEnum = {
  email: 'email',
  token: 'token',
  subid: 'subid',
  testType: 'testType'
};

exports.Prisma.TrialCodeOrderByRelevanceFieldEnum = {
  code: 'code'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  email: 'email',
  password: 'password',
  profileImage: 'profileImage',
  firstName: 'firstName',
  lastName: 'lastName',
  externalId: 'externalId'
};

exports.Prisma.UserSectionOrderByRelevanceFieldEnum = {
  externalId: 'externalId'
};

exports.Prisma.UserTokenOrderByRelevanceFieldEnum = {
  access: 'access',
  refresh: 'refresh'
};

exports.Prisma.q_instancesOrderByRelevanceFieldEnum = {
  option_key: 'option_key',
  option_val: 'option_val'
};

exports.Prisma.q_optionsOrderByRelevanceFieldEnum = {
  label: 'label',
  key: 'key'
};

exports.Prisma.q_questionnairesOrderByRelevanceFieldEnum = {
  name: 'name',
  subtitle: 'subtitle'
};

exports.Prisma.q_questionsOrderByRelevanceFieldEnum = {
  label: 'label',
  name: 'name',
  subtext: 'subtext'
};

exports.Prisma.q_sectionsOrderByRelevanceFieldEnum = {
  label: 'label',
  subtext: 'subtext'
};

exports.Prisma.q_sharedOrderByRelevanceFieldEnum = {
  name: 'name',
  email: 'email',
  token: 'token'
};

exports.Prisma.v1_users_reportsOrderByRelevanceFieldEnum = {
  subid: 'subid'
};

exports.Prisma.v1_rules_importOrderByRelevanceFieldEnum = {
  datasetid: 'datasetid'
};

exports.Prisma.v1_rules_templates_importOrderByRelevanceFieldEnum = {
  datasetid: 'datasetid',
  label: 'label',
  content: 'content'
};
exports.AssessmentType = exports.$Enums.AssessmentType = {
  MINDPRINT_SURVEY: 'MINDPRINT_SURVEY',
  MINDPRINT_SURVEY_V2: 'MINDPRINT_SURVEY_V2',
  MINDPRINT_ATT_SCREENER: 'MINDPRINT_ATT_SCREENER',
  MINDPRINT_SURVEY_V2_TRIAL: 'MINDPRINT_SURVEY_V2_TRIAL'
};

exports.AssessmentStatus = exports.$Enums.AssessmentStatus = {
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  PROCESSED: 'PROCESSED'
};

exports.StrategyEval = exports.$Enums.StrategyEval = {
  Best_Practice: 'Best_Practice',
  Social_and_Emotional: 'Social_and_Emotional',
  Stronger_Verbal_Reasoning: 'Stronger_Verbal_Reasoning',
  Stronger_Verbal_Skills: 'Stronger_Verbal_Skills',
  Stronger_Visual_Reasoning__Abstract___Spatial_: 'Stronger_Visual_Reasoning__Abstract___Spatial_',
  Stronger_Visual_Skills__Abstract___Spatial_: 'Stronger_Visual_Skills__Abstract___Spatial_',
  Support_Verbal_Reasoning: 'Support_Verbal_Reasoning',
  Support_Verbal_Skills: 'Support_Verbal_Skills',
  Support_Visual_Reasoning__Abstract___Spatial_: 'Support_Visual_Reasoning__Abstract___Spatial_',
  Support_Visual_Skills__Abstract___Spatial_: 'Support_Visual_Skills__Abstract___Spatial_',
  Support_Spatial___Visual_Motor: 'Support_Spatial___Visual_Motor',
  Support_Executive_Functions___Speed: 'Support_Executive_Functions___Speed',
  Support_Executive_Functions_Faster_Speed: 'Support_Executive_Functions_Faster_Speed',
  Support_Slower_Speed: 'Support_Slower_Speed',
  Support_Flexible_Thinking: 'Support_Flexible_Thinking',
  Support_Memory: 'Support_Memory',
  Test_Taking: 'Test_Taking',
  Support_Test_Anxiety: 'Support_Test_Anxiety'
};

exports.BoostCategory = exports.$Enums.BoostCategory = {
  HABIT: 'HABIT',
  HELP: 'HELP'
};

exports.StrategySubject = exports.$Enums.StrategySubject = {
  Math: 'Math',
  Study_Skills: 'Study_Skills',
  Reading___Writing: 'Reading___Writing',
  Standardized_Test_Prep: 'Standardized_Test_Prep'
};

exports.CustomRuleType = exports.$Enums.CustomRuleType = {
  NEED: 'NEED',
  STRENGTH: 'STRENGTH',
  RECOMMENDATION: 'RECOMMENDATION'
};

exports.EntityType = exports.$Enums.EntityType = {
  USER: 'USER',
  ROSTER: 'ROSTER',
  OTHER: 'OTHER'
};

exports.PredictiveOutcomeMetricType = exports.$Enums.PredictiveOutcomeMetricType = {
  SCALE_SCORE: 'SCALE_SCORE',
  PERCENTILE: 'PERCENTILE'
};

exports.AssessmentSourceType = exports.$Enums.AssessmentSourceType = {
  ACT: 'ACT',
  I_READY: 'I_READY',
  MAP: 'MAP',
  SAT: 'SAT'
};

exports.ReportType = exports.$Enums.ReportType = {
  MINDPRINT_COMPREHENSIVE: 'MINDPRINT_COMPREHENSIVE',
  STUDENT_PROFILE: 'STUDENT_PROFILE',
  ACT: 'ACT',
  SAT: 'SAT',
  SAT_ACT: 'SAT_ACT',
  NWEA: 'NWEA',
  STANDARD_SCORES: 'STANDARD_SCORES',
  I_READY_ELA: 'I_READY_ELA',
  I_READY_MATH: 'I_READY_MATH',
  MAP_MATH: 'MAP_MATH',
  MAP_READING: 'MAP_READING'
};

exports.ReportStatus = exports.$Enums.ReportStatus = {
  UNDER_REVIEW: 'UNDER_REVIEW',
  REVIEWED: 'REVIEWED',
  UPDATED: 'UPDATED',
  LETS_MEET: 'LETS_MEET',
  SENT_MANUALLY: 'SENT_MANUALLY',
  SENT_AUTOMATICALLY: 'SENT_AUTOMATICALLY',
  SHARED_WITH_STUDENT: 'SHARED_WITH_STUDENT',
  SENT_AS_TRIAL: 'SENT_AS_TRIAL'
};

exports.ReportAccessLogEvent = exports.$Enums.ReportAccessLogEvent = {
  VIEW: 'VIEW',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE'
};

exports.ReportFlagType = exports.$Enums.ReportFlagType = {
  COMPLEX_REASONING_MISSING: 'COMPLEX_REASONING_MISSING',
  COMPLEX_REASONING_EXTRA: 'COMPLEX_REASONING_EXTRA',
  MEMORY_MISSING: 'MEMORY_MISSING',
  MEMORY_EXTRA: 'MEMORY_EXTRA',
  EXECUTIVE_FUNCTION_MISSING: 'EXECUTIVE_FUNCTION_MISSING',
  EXECUTIVE_FUNCTION_EXTRA: 'EXECUTIVE_FUNCTION_EXTRA',
  PROCESSING_SPEED_MISSING: 'PROCESSING_SPEED_MISSING',
  PROCESSING_SPEED_EXTRA: 'PROCESSING_SPEED_EXTRA',
  HAS_ELL_MATCH: 'HAS_ELL_MATCH',
  HAS_ADMIN_COMMENTS: 'HAS_ADMIN_COMMENTS',
  RULE_TEMPLATE_STRENGTHS_ISSUE: 'RULE_TEMPLATE_STRENGTHS_ISSUE',
  RULE_TEMPLATE_STRENGTHS_MISSING: 'RULE_TEMPLATE_STRENGTHS_MISSING',
  RULE_TEMPLATE_STRENGTHS_EXTRA: 'RULE_TEMPLATE_STRENGTHS_EXTRA',
  RULE_TEMPLATE_NEEDS_ISSUE: 'RULE_TEMPLATE_NEEDS_ISSUE',
  RULE_TEMPLATE_NEEDS_MISSING: 'RULE_TEMPLATE_NEEDS_MISSING',
  RULE_TEMPLATE_NEEDS_EXTRA: 'RULE_TEMPLATE_NEEDS_EXTRA',
  RULE_TEMPLATE_RECOMMENDATIONS_ISSUE: 'RULE_TEMPLATE_RECOMMENDATIONS_ISSUE',
  REVIEW_GENERAL: 'REVIEW_GENERAL',
  REVIEW_SCORE_ISSUE: 'REVIEW_SCORE_ISSUE',
  REVIEW_RULE_MATCH_ISSUE: 'REVIEW_RULE_MATCH_ISSUE',
  REVIEW_TEXT_CHANGE_REQUIRED: 'REVIEW_TEXT_CHANGE_REQUIRED',
  OTHER_ISSUE: 'OTHER_ISSUE',
  MINOR_RULE_EXTRA: 'MINOR_RULE_EXTRA'
};

exports.RosterRole = exports.$Enums.RosterRole = {
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER',
  SUPPORT: 'SUPPORT'
};

exports.RuleCategory = exports.$Enums.RuleCategory = {
  COMPLEX_REASONING: 'COMPLEX_REASONING',
  MEMORY: 'MEMORY',
  EXECUTIVE_FUNCTION: 'EXECUTIVE_FUNCTION',
  PROCESSING_SPEED: 'PROCESSING_SPEED',
  MINOR: 'MINOR',
  OTHER: 'OTHER',
  CUSTOM: 'CUSTOM'
};

exports.RuleTier = exports.$Enums.RuleTier = {
  CR_LOW: 'CR_LOW',
  M_LOW: 'M_LOW',
  EF_LOW: 'EF_LOW',
  EF_LOW_D: 'EF_LOW_D'
};

exports.RuleParentTier = exports.$Enums.RuleParentTier = {
  CR_LOW: 'CR_LOW',
  M_LOW: 'M_LOW',
  EF_LOW: 'EF_LOW',
  EF_LOW_D: 'EF_LOW_D'
};

exports.RuleReportType = exports.$Enums.RuleReportType = {
  COMPREHENSIVE: 'COMPREHENSIVE',
  TP_ACT: 'TP_ACT',
  TP_SAT: 'TP_SAT'
};

exports.MinorRuleCategory = exports.$Enums.MinorRuleCategory = {
  CONCUSSION: 'CONCUSSION',
  ELL: 'ELL',
  CONSULT: 'CONSULT',
  EF_MINOR: 'EF_MINOR',
  MEM_MINOR: 'MEM_MINOR',
  MOOD: 'MOOD',
  FLUENCY: 'FLUENCY',
  REASONING_MINOR: 'REASONING_MINOR',
  PROCESSING_MINOR: 'PROCESSING_MINOR'
};

exports.RuleTemplateType = exports.$Enums.RuleTemplateType = {
  STRENGTH: 'STRENGTH',
  NEED: 'NEED',
  RECOMMENDATION: 'RECOMMENDATION',
  OVERALL: 'OVERALL',
  READING: 'READING',
  ENGLISH: 'ENGLISH',
  MATH: 'MATH',
  SCIENCE: 'SCIENCE',
  FOOTNOTE: 'FOOTNOTE',
  CUSTOM_STRENGTH: 'CUSTOM_STRENGTH',
  CUSTOM_NEED: 'CUSTOM_NEED',
  CUSTOM_RECOMMENDATION: 'CUSTOM_RECOMMENDATION'
};

exports.StudentGender = exports.$Enums.StudentGender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
};

exports.TenantType = exports.$Enums.TenantType = {
  DISTRICT: 'DISTRICT',
  SCHOOL: 'SCHOOL',
  FRANCHISE: 'FRANCHISE',
  TUTOR: 'TUTOR',
  PARENT: 'PARENT',
  CORPORATE: 'CORPORATE',
  OTHER: 'OTHER'
};

exports.AccountState = exports.$Enums.AccountState = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING_DELETION: 'PENDING_DELETION',
  DELETED: 'DELETED'
};

exports.UserRole = exports.$Enums.UserRole = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
  SITE_ADMIN: 'SITE_ADMIN',
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
  PENDING: 'PENDING'
};

exports.UserSectionRole = exports.$Enums.UserSectionRole = {
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER'
};

exports.q_map_question_questionnaire_type = exports.$Enums.q_map_question_questionnaire_type = {
  select: 'select',
  radio: 'radio',
  text: 'text',
  textarea: 'textarea',
  checkbox: 'checkbox'
};

exports.v1_rules_import_category = exports.$Enums.v1_rules_import_category = {
  COMPLEX_REASONING: 'COMPLEX_REASONING',
  MEMORY: 'MEMORY',
  EXECUTIVE_FUNCTION: 'EXECUTIVE_FUNCTION',
  PROCESSING_SPEED: 'PROCESSING_SPEED',
  MINOR: 'MINOR',
  OTHER: 'OTHER',
  CUSTOM: 'CUSTOM'
};

exports.v1_rules_import_tier = exports.$Enums.v1_rules_import_tier = {
  CR_LOW: 'CR_LOW',
  M_LOW: 'M_LOW',
  EF_LOW: 'EF_LOW',
  EF_LOW_D: 'EF_LOW_D'
};

exports.v1_rules_import_report_type = exports.$Enums.v1_rules_import_report_type = {
  COMPREHENSIVE: 'COMPREHENSIVE',
  TP_ACT: 'TP_ACT',
  TP_SAT: 'TP_SAT'
};

exports.v1_rules_import_minor_category = exports.$Enums.v1_rules_import_minor_category = {
  CONCUSSION: 'CONCUSSION',
  ELL: 'ELL',
  CONSULT: 'CONSULT',
  EF_MINOR: 'EF_MINOR',
  MEM_MINOR: 'MEM_MINOR',
  MOOD: 'MOOD',
  FLUENCY: 'FLUENCY',
  REASONING_MINOR: 'REASONING_MINOR',
  PROCESSING_MINOR: 'PROCESSING_MINOR'
};

exports.v1_rules_templates_import_type = exports.$Enums.v1_rules_templates_import_type = {
  strength: 'strength',
  need: 'need',
  recommendation: 'recommendation',
  reading: 'reading',
  english: 'english',
  math: 'math',
  science: 'science',
  footnote: 'footnote',
  custom_strength: 'custom_strength',
  custom_need: 'custom_need',
  custom_recommendation: 'custom_recommendation'
};

exports.Prisma.ModelName = {
  Assessment: 'Assessment',
  AssessmentRule: 'AssessmentRule',
  Branding: 'Branding',
  Boost: 'Boost',
  Config: 'Config',
  ContactForm: 'ContactForm',
  CustomRule: 'CustomRule',
  ExternalId: 'ExternalId',
  Integration: 'Integration',
  Lift: 'Lift',
  Organization: 'Organization',
  PredictiveOutcome: 'PredictiveOutcome',
  Product: 'Product',
  ProductBySkill: 'ProductBySkill',
  ProfileImage: 'ProfileImage',
  Report: 'Report',
  ReportAccessLog: 'ReportAccessLog',
  ReportFlag: 'ReportFlag',
  Roster: 'Roster',
  RosterMember: 'RosterMember',
  Rule: 'Rule',
  RuleTemplate: 'RuleTemplate',
  Score: 'Score',
  ScoreCnb: 'ScoreCnb',
  Section: 'Section',
  Site: 'Site',
  Student: 'Student',
  Tenant: 'Tenant',
  TenantIntegration: 'TenantIntegration',
  ThirdPartyProvider: 'ThirdPartyProvider',
  Trial: 'Trial',
  TrialAccount: 'TrialAccount',
  TrialCode: 'TrialCode',
  User: 'User',
  UserOrganization: 'UserOrganization',
  UserSection: 'UserSection',
  UserSite: 'UserSite',
  UserToken: 'UserToken',
  q_instances: 'q_instances',
  q_map_customer_questionnaire: 'q_map_customer_questionnaire',
  q_map_option_cognitive_skill: 'q_map_option_cognitive_skill',
  q_map_option_question: 'q_map_option_question',
  q_map_question_questionnaire: 'q_map_question_questionnaire',
  q_map_questionnaire_section: 'q_map_questionnaire_section',
  q_options: 'q_options',
  q_questionnaires: 'q_questionnaires',
  q_questions: 'q_questions',
  q_sections: 'q_sections',
  q_shared: 'q_shared',
  v1_users_reports: 'v1_users_reports',
  v1_rules_import: 'v1_rules_import',
  v1_rules_templates_import: 'v1_rules_templates_import'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
